'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unsubscribeSelector = exports.paymentFormValuesSelector = exports.paymentSelector = exports.couponSelector = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash');

var _reselect = require('reselect');

var _currentUserSelector = require('../../currentUserSelector');

var _paymentUtil = require('../../../../common/payment/paymentUtil');

var _teamManagementSelectors = require('../team/teamManagementSelectors');

var CARD_DEFAULT = {
    name: ' ',
    number: '•••• •••• •••• ••••',
    expiry: '••/••',
    cvc: '•••',
    postCode: ' ',
    cardPrefilled: true
};

var getPaymentModal = function getPaymentModal(state) {
    return state.getIn(['app', 'modal', 'payment']);
};

var customerSelector = (0, _reselect.createSelector)(_currentUserSelector.getCurrentUser, function (currentUser) {
    return currentUser.get('customer');
});

var subscriptionSelector = (0, _reselect.createSelector)(customerSelector, function (customer) {
    return customer && customer.getIn(['subscriptions', 'data']) && customer.getIn(['subscriptions', 'data']).first();
});

var couponSelector = exports.couponSelector = (0, _reselect.createSelector)(subscriptionSelector, getPaymentModal, function (subscription, paymentModal) {
    return paymentModal.get('coupon') || subscription && subscription.getIn(['discount', 'coupon']);
});

var cardSelector = (0, _reselect.createSelector)(_currentUserSelector.getCurrentUser, customerSelector, function (currentUser, customer) {
    if (!customer && currentUser && currentUser.get('customerId')) return CARD_DEFAULT;
    if (customer && customer.get('fetching')) return CARD_DEFAULT;

    if (customer && !customer.get('fetching')) {
        var card = customer.getIn(['sources', 'data']) && customer.getIn(['sources', 'data']).first();
        if (!card) return {};

        var last4 = card.get('last4');
        var expMonth = (0, _lodash.padStart)(card.get('exp_month'), 2, '0');
        var expYear = card.get('exp_year').toString().substr(2);
        var brand = card.get('brand').toLowerCase();

        var cardName = card.get('name');
        var postcode = card.get('address_zip');

        return _extends({}, CARD_DEFAULT, {
            number: (0, _paymentUtil.describeCardNumber)(last4),
            expiry: expMonth + '/' + expYear,
            cardName: cardName,
            postcode: postcode,
            brand: brand
        });
    }

    return {};
});

var paymentSelector = exports.paymentSelector = (0, _reselect.createSelector)(_currentUserSelector.getCurrentUser, getPaymentModal, customerSelector, subscriptionSelector, _teamManagementSelectors.selectedTeamMemberIdsSelector, couponSelector, function (currentUser, paymentModal, customer, subscription, teamMemberIds, coupon) {
    return {
        currentUser: currentUser,
        viewState: paymentModal.get('viewState'),
        teamMemberIds: teamMemberIds,
        planVolume: teamMemberIds.size,
        plans: paymentModal.get('plans'),
        coupon: coupon,
        upcomingInvoice: paymentModal.get('upcomingInvoice'),
        customer: customer,
        subscription: subscription
    };
});

var getProationDate = (0, _reselect.createSelector)(getPaymentModal, function (paymentModal) {
    return paymentModal.get('prorateDate');
});

var paymentFormValuesSelector = exports.paymentFormValuesSelector = (0, _reselect.createSelector)(cardSelector, getProationDate, subscriptionSelector, function (card, prorateDate, subscription) {
    return {
        initialValues: _extends({}, card, {
            prorateDate: prorateDate,
            plan: subscription && subscription.getIn(['plan', 'interval']) || 'year'
        })
    };
});

var unsubscribeSelector = exports.unsubscribeSelector = (0, _reselect.createSelector)(_currentUserSelector.getCurrentUser, subscriptionSelector, function (currentUser, subscription) {
    return {
        currentUser: currentUser,
        subscription: subscription
    };
});


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/payment/paymentSelector.js
// module id = 308
// module chunks = 0